<template>
  <b-row class="overdue-row">
    <b-badge
      v-if="getOverdueCount(user)"
      pill
      variant="danger"
      class="large badge-item"
    >
      {{ getOverdueCount(user) }} Overdue item{{
        getOverdueCount(user) > 1 ? "s" : ""
      }}
    </b-badge>
    <div v-else class="no-overdue"></div>
  </b-row>
</template>

<script>
export default {
  name: "OverdueRow",
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    yesterday() {
      return new Date(new Date().setDate(new Date().getDate() - 1))
    }
  },
  created() {},
  methods: {
    /**
     * Gets amount of overdue tasks/tickets for this user
     * @param user
     * @returns {*}
     */
    getOverdueCount(user) {
      const overdueTasks =
        user.tasks.filter(
          x => !x.completed && new Date(x.end) <= this.yesterday
        ).length ?? 0
      const overdueTickets =
        user.tickets.filter(
          x => !x.completed && new Date(x.end) <= this.yesterday
        ).length ?? 0
      return overdueTasks + overdueTickets
    }
  }
}
</script>

<style scoped>
.overdue-row {
  text-align: center;
  margin-bottom: 0.5rem;
}

.badge-item {
  margin: auto !important;
}

.no-overdue {
  margin: 0.5rem;
}
</style>
